import { render, staticRenderFns } from "./discounts.vue?vue&type=template&id=4337d899&"
import script from "./discounts.vue?vue&type=script&lang=js&"
export * from "./discounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports